<template>
  <tr v-if="emailExistsInContactEmailAddresses" class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ contactRequest.full_name }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ emailAddress }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ status }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ deliveryStatus }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <BaseButton
        v-if="!isSent"
        success
        small
        :disabled="sendDisabled"
        @click="handleSendEmailMessage"
      >
        Send
      </BaseButton>
    </td>
  </tr>
  <tr v-else class="even:bg-white odd:bg-gray-50">
    <td colspan="5" class="px-4 py-4 text-sm text-red-600">
      <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg
              class="h-5 w-5 text-yellow-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-yellow-700">
              No valid contact email address matched with email address provided by
              <strong>{{ contactRequest.full_name }}</strong> contact request.
            </p>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { capitalize } from 'lodash-es';

export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
    emailMessage: {
      type: Object,
      required: true,
    },
    onSendEmailMessage: {
      type: Function,
      required: true,
    },
    sendDisabled: Boolean,
  },
  computed: {
    trackingLogs() {
      return this.contactRequest?.email_message_tracking_logs || [];
    },
    currentEmailMessageTrackingLog() {
      if (!this.emailMessage) {
        return null;
      }

      return (
        this.trackingLogs.find(
          (trackingLog) => trackingLog.email_message_id === this.emailMessage.id
        ) || null
      );
    },
    status() {
      const { status = '' } = this.currentEmailMessageTrackingLog || {};

      return status ? capitalize(status) : '';
    },
    emailAddress() {
      return this.currentEmailMessageTrackingLog?.to_address || '';
    },
    emailExistsInContactEmailAddresses() {
      const contactRequestEmailAddress = this.contactRequest.email;
      return (this.contactRequest?.contact_email_addresses || [])
        .map((emailAddress) => emailAddress.address)
        .some((emailAddress) => emailAddress === contactRequestEmailAddress);
    },
    deliveryStatus() {
      return capitalize(this.currentEmailMessageTrackingLog?.status || '');
    },
    isSent() {
      return this.currentEmailMessageTrackingLog !== null;
    },
  },
  methods: {
    handleSendEmailMessage() {
      this.onSendEmailMessage({ contact_request_ids: [this.contactRequest.id] });
    },
  },
};
</script>
